"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowMeter = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'FlowMeter';
class FlowMeter extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        super(ob.type || typeName, ob);
        this.purposeType = (_a = ob.purposeType) !== null && _a !== void 0 ? _a : '';
        // this.meterType = ob.meterType
        // this.diameter = ob.diameter
        this.maximumFlowRate = (_c = (_b = ob.maximumFlowRate) !== null && _b !== void 0 ? _b : ob.maxrate) !== null && _c !== void 0 ? _c : null;
        // this.setFlowRate = ob.setFlowRate ?? null
        this.flow = (_d = ob.flow) !== null && _d !== void 0 ? _d : null;
        this.location = (_e = ob.location) !== null && _e !== void 0 ? _e : ob.position;
        this.pulseCounterFrequency = (_f = ob.pulseCounterFrequency) !== null && _f !== void 0 ? _f : null;
        this.pulseCountCalibration = (_g = ob.pulseCountCalibration) !== null && _g !== void 0 ? _g : null;
        this.image = (_h = ob.image) !== null && _h !== void 0 ? _h : null;
        this.flowPerPulse = (_k = (_j = ob.flowPerPulse) !== null && _j !== void 0 ? _j : ob.flowperpulse) !== null && _k !== void 0 ? _k : null;
        this.flowToday = (_l = ob.flowToday) !== null && _l !== void 0 ? _l : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Water Flow Meter',
            },
            purposeType: {
                type: 'String',
                editable: true,
                label: 'Purpose/ Type',
                name: 'purpose/Type',
                description: 'Purpose/ type of Flow',
            },
            meterType: {
                type: 'String',
                editable: true,
                label: 'Meter Type',
                name: 'meterType',
                description: 'Meter type',
            },
            diameter: {
                type: 'Number',
                editable: true,
                label: 'Diameter',
                name: 'diameter',
                description: 'Diameter of Water Flow pipe - mm',
            },
            maximumFlowRate: {
                type: 'Number',
                editable: true,
                label: 'Maximum Flow Rate (L/m)',
                name: 'maximumFlowRate',
                description: 'Maximum flow rate ',
            },
            // setFlowRate: {
            //   type: "Number",
            //   editable: true,
            //   label: "Set Flow Rate",
            //   name: "setFlowRate",
            //   description: "Flow rate set for the Water Flow",
            // },
            // flow: {
            //   type: "Number",
            //   editable: true,
            //   label: "Flow",
            //   name: "flow",
            //   description: "Water flow  litres/ sec and cubic metres/ sec",
            // },
            location: {
                type: 'object',
                editable: true,
                label: 'Location',
                name: 'location',
                description: 'Location of  Water Flow Meter (lat/ long)',
            },
            // pulseCounterFrequency: {
            //   type: "Number",
            //   editable: true,
            //   label: "Pulse counter frequency",
            //   name: "pulseCounterFrequency",
            //   description: "Frequency of pulse counts from meter to measure flow",
            // },
            pulseFlowAmount: {
                type: 'Number',
                editable: true,
                label: 'Flow (Liters) per pulse',
                name: 'pulseFlowAmount',
                description: 'Flow per pulse to calculate water flow',
            },
            // pulseCountCalibration: {
            //   type: "Number",
            //   editable: true,
            //   label: "Pulse Count Calibration",
            //   name: "pulseCountCalibration",
            //   description: "Calibration of pulse counts to calculate water flow",
            // },
            image: {
                type: 'String',
                editable: true,
                label: 'Image',
                name: 'image',
                description: 'Photograph of Water Flow meter',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.FlowMeter = FlowMeter;
